import { Form, Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import mask from '../../utils/mask';
import TitleFilter from '../TextFilter';

export const SelectParceiroDepositante: React.FC = () => {
  const parceiro = useSelector((state: ApplicationState) => state.auth.user?.inscricoesEstaduais);
  const { Option } = Select;

  const onChangeParc = (values: any) => {
    localStorage.setItem(`codDepositante${window.location.pathname}`, values);
  };

  const children = [];
  children.push(
    parceiro?.map((inscData, index) => (
      <Option
        title={inscData.nomeParceiro}
        className="optionselect"
        value={inscData.codParceiro}
        key={inscData.codParceiro}
      >
        CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjcpf)} <br />
        Inscrição estadual: {inscData.inscricaoEstadual} <br />
        Nome: {inscData.nomeParceiro} - Código: {inscData.codParceiro}
        <hr />
      </Option>
    ))
  );
  const localStorageItensPersist =
    localStorage.getItem(`codDepositante${window.location.pathname}`) || '';
  return (
    <>
      <Form.Item label={<TitleFilter>Depositante</TitleFilter>} name="codDepositante">
        <Select
          data-cy="depositante"
          showSearch
          style={{ width: '100%' }}
          filterOption={(inputValue, element) =>
            element?.props.children
              .toString()
              .toLowerCase()
              .includes(inputValue.toLowerCase())
          }
          onChange={onChangeParc}
          defaultValue={localStorageItensPersist}
        >
          {children}
        </Select>
      </Form.Item>
    </>
  );
};
